import { useState, useEffect } from 'react';
import { Element, scroller } from 'react-scroll';
import { searchContext } from '../../context/Context';
import ManageGrid from '../../modules/search/searchGrid/components/table/ManageGrid';
import { getAllColumns } from '../Table/columns/index';
import { isEvidenceOnlyMapping, isSummaryOnlyMapping } from '../../config/mappingRules';
import { getDefaultEvidenceFiltersForMapping } from '../../utils/mappingDefaultEvidenceFilters';

function MappingResults({ mappingContent, dispatch }) {
  const { view, source, tab, setSearchItems } = searchContext();
  const [isInfoSidebarOpen, setIsInfoSidebarOpen] = useState(false);

  const column = getAllColumns().find(c => c.name === mappingContent.name);
  const title = column?.header?.props?.children || column?.header || mappingContent.name;

  const getDefaultEvidenceFilterValue = getDefaultEvidenceFiltersForMapping;

  const evidenceOnly = isEvidenceOnlyMapping(mappingContent?.name);
  const summaryOnly = isSummaryOnlyMapping(mappingContent?.name);
  const showSummary = !evidenceOnly;
  const showEvidence = !summaryOnly;

  const [tablePanel, setTablePanel] = useState<'summary' | 'evidence'>(() =>
    !showSummary && showEvidence ? 'evidence' : 'summary',
  );

  useEffect(() => {
    if (!showSummary && showEvidence) setTablePanel('evidence');
    else if (showSummary && !showEvidence) setTablePanel('summary');
    else if (showSummary && showEvidence) setTablePanel('summary');
  }, [mappingContent, showSummary, showEvidence]);

  const mappingSummaryEvidenceToggle =
    showSummary && showEvidence
      ? {
          showSummary: true as const,
          showEvidence: true as const,
          active: tablePanel,
          onChange: setTablePanel,
        }
      : showSummary && !showEvidence
        ? {
            showSummary: true as const,
            showEvidence: false as const,
            active: 'summary' as const,
            onChange: () => {},
          }
        : {
            showSummary: false as const,
            showEvidence: true as const,
            active: 'evidence' as const,
            onChange: () => {},
          };

  useEffect(() => {
    const target =
      showSummary && showEvidence
        ? tablePanel === 'summary'
          ? 'MappingSummary'
          : 'MappingEvidence'
        : showSummary
          ? 'MappingSummary'
          : 'MappingEvidence';
    scroller.scrollTo(target, {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart',
    });
  }, [mappingContent, showSummary, showEvidence, tablePanel]);

  return (
    <>
      <div className="titEtiqueta pt-12">
        <span>{title} Mapping</span>
      </div>
      <Element name="MappingSummary">
        {showSummary && mappingContent?.mappingItems && showEvidence && tablePanel === 'summary' && (
          <ManageGrid
            view={view}
            source={source}
            tab={tab}
            searchItems={mappingContent?.mappingItems}
            setSearchItems={setSearchItems}
            isEvidence={false}
            isMapping={true}
            isInfoSidebarOpen={isInfoSidebarOpen}
            mappingContent={mappingContent}
            setIsInfoSidebarOpen={setIsInfoSidebarOpen}
            dispatch={dispatch}
            restrictChemical={false}
            summaryEvidenceToggle={mappingSummaryEvidenceToggle}
          />
        )}
        {showSummary && mappingContent?.mappingItems && !showEvidence && (
          <ManageGrid
            view={view}
            source={source}
            tab={tab}
            searchItems={mappingContent?.mappingItems}
            setSearchItems={setSearchItems}
            isEvidence={false}
            isMapping={true}
            isInfoSidebarOpen={isInfoSidebarOpen}
            mappingContent={mappingContent}
            setIsInfoSidebarOpen={setIsInfoSidebarOpen}
            dispatch={dispatch}
            restrictChemical={false}
            summaryEvidenceToggle={mappingSummaryEvidenceToggle}
          />
        )}
      </Element>
      <Element name="MappingEvidence">
        {showEvidence && showSummary && tablePanel === 'evidence' && (
          <ManageGrid
            view={view}
            source={source}
            tab={tab}
            searchItems={mappingContent?.mappingItems}
            setSearchItems={setSearchItems}
            isEvidence={true}
            isMapping={true}
            setIsInfoSidebarOpen={setIsInfoSidebarOpen}
            mappingContent={mappingContent}
            isInfoSidebarOpen={isInfoSidebarOpen}
            dispatch={dispatch}
            restrictChemical={false}
            defaultFilterValue={getDefaultEvidenceFilterValue(mappingContent)}
            summaryEvidenceToggle={mappingSummaryEvidenceToggle}
          />
        )}
        {showEvidence && !showSummary && (
          <ManageGrid
            view={view}
            source={source}
            tab={tab}
            searchItems={mappingContent?.mappingItems}
            setSearchItems={setSearchItems}
            isEvidence={true}
            isMapping={true}
            setIsInfoSidebarOpen={setIsInfoSidebarOpen}
            mappingContent={mappingContent}
            isInfoSidebarOpen={isInfoSidebarOpen}
            dispatch={dispatch}
            restrictChemical={false}
            defaultFilterValue={getDefaultEvidenceFilterValue(mappingContent)}
            summaryEvidenceToggle={mappingSummaryEvidenceToggle}
          />
        )}
      </Element>
    </>
  );
}
export default MappingResults;
